// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"e9f6254d","100":"75191a29","108":"ee977bdd","373":"d714b70f","453":"7c2f0c3c","857":"97bdf5b6","994":"7f6353ef"}[chunkId] + ".chunk.js";
};